import React, { useState } from "react";
import { Link}  from "react-router-dom";
import { Button } from "antd";

import HashtagFollowButton from "../hashtag-follow-button";
import { copyLink } from "utils";
import { Localize } from "components/service";


const HashtagCardMenu = (props) => {

    const {
        relation : {
            slug,
            relationship_id
        },
        post,
        hidePopup,
    } = props;

    const [ meFollowing, setMeFollowing ] = useState( !!props.relation );

    return (
        <ul className="modal-actions-list company-link-hover">
            <li>
                <HashtagFollowButton
                    buttonClass={ meFollowing ? 'bold-text' : ''}
                    id={ relationship_id }
                    meFollowing={ meFollowing }
                    onUpdateAction={ setMeFollowing }
                >
                    <Localize wrap>
                        { meFollowing ?
                            "FOLLOW.Button_Text_UnfollowHashtag":
                            "FOLLOW.Button_Text_FollowHashtag"
                        }
                    </Localize>
                </HashtagFollowButton>
            </li>
            <li>
                <Button onClick={ () => copyLink(`/post/${post.order_slug.replace(/[=]/g, '')}`) }>
                    <Localize wrap>MENUS.Button_Text_CopyLink</Localize>
                </Button>
            </li>
            <li>
                <Link to={`/tag/${ slug }`}>
                    <Localize wrap>MENUS.Link_Text_GoHashtag</Localize>
                </Link>
            </li>
            <li>
                <button onClick={ hidePopup }>
                    <Localize wrap>MENUS.Button_Text_Cancel</Localize>
                </button>
            </li>
        </ul>
    );
};

export default HashtagCardMenu;